import React from 'react';
import { FormControl, InputLabel, TextField, IconButton, Tooltip, Box } from '@mui/material';
import { alpha } from '@mui/material/styles';

function FilterTextInput({
    value,
    onChange,
    sx,
    placeholder,
    matchCase,
    words,
    onMatchCaseChange,
    onWordsChange,
    showToggles = false,
}) {
    return (
        <FormControl variant="outlined" color="primary" size="small" sx={{ minWidth: 200, position: 'relative', ...sx }}>
            <InputLabel
                shrink
                sx={{
                    fontSize: '13px',
                    fontWeight: 700,
                    top: '-6px',
                    left: '-4px',
                    color: alpha('#3b3c3b', 0.6),
                }}
            >
            </InputLabel>
            <TextField
                variant="outlined"
                size="small"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
            />
            {showToggles && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: -19,
                        right: 0,
                        display: 'flex',
                        gap: 0.5,
                    }}
                >
                    <Tooltip title="Match case">
                        <IconButton
                            size="small"
                            onClick={() => onMatchCaseChange?.(!matchCase)}
                            sx={{
                                width: 24,
                                height: 24,
                                border: '1px solid',
                                borderRadius: 0.5,
                                borderColor: matchCase ? 'primary.main' : alpha('#3b3c3b', 0.3),
                                backgroundColor: matchCase ? 'primary.main' : 'transparent',
                                color: matchCase ? '#fff' : alpha('#3b3c3b', 0.6),
                                fontSize: 9,
                                fontWeight: 700,
                                padding: 0,
                                '&:hover': {
                                    backgroundColor: matchCase
                                        ? 'primary.dark'
                                        : alpha('#3b3c3b', 0.05),
                                },
                            }}
                        >
                            Aa
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Whole words">
                        <IconButton
                            size="small"
                            onClick={() => onWordsChange?.(!words)}
                            sx={{
                                width: 24,
                                height: 24,
                                border: '1px solid',
                                borderRadius: 0.5,
                                borderColor: words ? 'primary.main' : alpha('#3b3c3b', 0.3),
                                backgroundColor: words ? 'primary.main' : 'transparent',
                                color: words ? '#fff' : alpha('#3b3c3b', 0.6),
                                fontSize: 9,
                                fontWeight: 700,
                                padding: 0,
                                '&:hover': {
                                    backgroundColor: words
                                        ? 'primary.dark'
                                        : alpha('#3b3c3b', 0.05),
                                },
                            }}
                        >
                            W
                        </IconButton>
                    </Tooltip>
                </Box>
            )}
        </FormControl>
    );
}

export default FilterTextInput;
